import createVueApp from '@/common/create_app'
import sidebar from '@/config/sidebars/lsa'

Styxie.Initializers.LsaBidEstimator = {
  index: async(props) => {
    const { default: Component } = await import('@/vue_widgets/lsa/bid_estimator/index.vue')
    createVueApp(Component, { props, sidebar })
  }
}
